<template>
  <withTopNav :leftText="$t('ChooseSaque.LeftText')" fixed>
  <div class="chooseSaque flex flex-col h-full pb-[100px]">
    <div class="flex-1 flex flex-col overflow-y-auto">
      <div class="flex-1 mx-5">
        <div class="my-[18px] text-[15px] text-white">{{ $t('ChooseSaque.ChooseWithdrawalChannel') }}</div>
        <template v-if="payType.length">
          <template v-for="(item, index) in payType" :key="item.id">
            <div class="relative">
              <button
                @click="
                  () => {
                    const queryParams = {
                      ...searchParams, // 将 searchParams 对象展开并添加到 queryParams 对象中
                      methodId: item.methodId,
                      min: item.minPayAmt,
                      max: item.maxPayAmt,
                      supportTypes: item.supportType,
                      type: item.type,
                    };
                    router.push({ path: '/Saque', query: queryParams });
                  }
                "
                class="w-[343px] h-[70px] mb-[12px] bg-[#151A1F] rounded-[10px] flex items-center justify-between pl-[40px] pr-[20px] border border-solid border-white"
              >
                <Image class="w-[100px] h-[36px]" :src="pixq" alt="" />
                <div class="w-[1px] h-[32px] bg-white"></div>
                <div class="flex items-center">
                  <div
                    class="w-[36px] h-[36px] rounded-[7px] border-[1px] border-solid border-white flex items-center justify-center text-white mr-12"
                  >
                    {{ index + 1 }}
                  </div>
                  <van-icon name="arrow" class="text-[14px] text-white" />
                </div>
              </button>
              <div
                v-if="item.type === 'TestPay'"
                class="absolute top-[-2px] right-[-10px] w-[20px] h-[20px] rounded-full bg-[red] text-white text-[10px] flex-center"
              >
                T
              </div>
            </div>
          </template>
        </template>
      </div>
      <div class="mx-5 text-center text-[13px] fixed bottom-8 text-white">
        {{ $t('ChooseSaque.AfterSuccessfulPayment') }}
      </div>
    </div>
  </div>
  </withTopNav>
</template>

<script setup lang="ts">
import { getPayChannel } from "@/api/saque";
import pixq from "@/themes/theme_a/views/DepositoQRcode/images/pixq.png";
import withTopNav from '@/layouts/withTopNav.vue'
const route = useRoute();
const router = useRouter();
const searchParams = ref(route.query);
const payType = ref<any>([]);

const getChannelList = async () => {
  try {
    const { data, code } = await getPayChannel({ type: "Withdrawal" });
    if (code === 1) {
      payType.value = data;
    }
  } catch (error) {
    console.log(error);
  }
};

onMounted(() => {
  getChannelList();
});
</script>

<style lang="scss" scoped></style>
